import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ba5c6b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex justify-space-between" }
const _hoisted_5 = { class: "text-subtitle-1" }
const _hoisted_6 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-subtitle mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-h6"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }

import { ref, computed, onBeforeMount, watch } from 'vue';
import crApi from '../service/CrApi';
import securityService from '../service/SecurityService';
import { useRouter } from "vue-router";
import moment from "moment";
import SpinnerComponent from "./SpinnerComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateListComponent',
  props: {
  allowCreate: {
    type: Boolean,
    default: true,
  },
  additionalOptions: {
    type: [Object, Array],
    default: () => ({}),
  },
  showDetails: {
    type: Boolean,
    default: true,
  },
  fieldContainerTitle: {
    type: String,
    default: 'Fields:',
  },
  showTemplateOptions: {
    type: Boolean,
    default: true,
  },
  value: {
    type: String,
    default: '',
  },
  prefix: {
    type: [String, Number],
    default: '',
  },
  showEdit: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: 'Output Format:'
  },
  modelValue: {
    type: String,
    default: ''
  },
  isAutomaticllyTamplate: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const router = ref(useRouter());
const templateNames = ref([]);
const isLoading = ref(false);
const allLoaded = ref(false);
const template = ref({});
const loadingTemplate = ref(false);
const isDeleted = ref(false);
const adminParams = ref({});
const idPrefix = ref('');
const allowCreate = ref(props.allowCreate);
const showDetails = ref(props.showDetails);
const showEdit = ref(props.showEdit);
const additionalOptions = ref(props.additionalOptions);
const fieldContainerTitle = ref(props.fieldContainerTitle);
const offset = ref(0);
const limit = ref(25);

const internalModelValue = ref(props.modelValue);

watch(() => props.modelValue, async () => {
  if (props.modelValue) {
    internalModelValue.value = props.modelValue;
    await loadTemplateDetails();
  }
});

watch(internalModelValue, (newVal) => {
  emit('update:modelValue', newVal);
});

onBeforeMount(async () => {
  await loadTemplates();
  if (props.modelValue) {
    await loadTemplateDetails();
  }
});

const allTemplateNames = computed(() => {
  let a = [];
  if (isDeleted.value) {
    a.push({ value: internalModelValue.value, title: 'TEMPLATE DELETED!' });
  }
  for (let k of Object.keys(props.additionalOptions)) {
    a.push({ value: k, title: props.additionalOptions[k] });
  }
  if (props.allowCreate) {
    a.push({ value: 'defineCustomTemplate', title: '-- Create New Template' });
  }
  for (let q of templateNames.value) {
    a.push({ value: q.templateId, title: q.templateName });
  }
  return a;
});

async function loadTemplates() {
  isLoading.value = true;
  try {
    let response = await crApi.requestV2('export_template/retrieve/', {
      ...adminParams.value,
      'website_token': securityService.getToken(),
      limit: limit.value,
      offset: offset.value,
      isAutomaticllyTamplate: props.isAutomaticllyTamplate
    });

    if (response.status == 1) {
      const newTemplates = response.template.filter(template => !templateNames.value.some(t => t['templateId'] === template['templateId']));
      templateNames.value.push(...newTemplates);
      offset.value += response.template.length;

      if (response.template.length < limit.value) {
        allLoaded.value = true; // No more items to load
      }
    }
  } catch (error) {
    console.error('Error loading templates:', error);
  } finally {
    isLoading.value = false;
  }
}

async function loadMore({ done }: { done?: (arg: string) => void } = {}) {
  if (isLoading.value || allLoaded.value) {
    done('empty');
    return;
  }
  isLoading.value = true;

  try {
    const response = await crApi.requestV2('export_template/retrieve/', {
      sortBy: 'templateName',
      response: 'extra',
      sortOrder: 'asc',
      website_token: securityService.getToken(),
      offset: offset.value,
      limit: limit.value,
      isAutomaticllyTamplate: props.isAutomaticllyTamplate
    });

    if (response && response.status === 1) {
      const newTemplates = response.template.filter(template => !templateNames.value.some(t => t['templateId'] === template['templateId']));
      templateNames.value.push(...newTemplates);
      offset.value += response.template.length;

      if (done) {
        done(response.template.length === 0 ? 'empty' : 'done');
      }
    }
  } catch (error) {
    console.error('Error loading templates:', error);
  } finally {
    isLoading.value = false;
  }
}

async function loadTemplateDetails() {
  if (!internalModelValue.value) {
    return;
  }

  loadingTemplate.value = true;

  try {
    let templateParams = { ...adminParams.value, 'templateId': internalModelValue.value, isAutomaticllyTamplate: props.isAutomaticllyTamplate, 'response': 'extra', 'website_token': securityService.getToken() };
    let response = await crApi.requestV2('export_template/retrieve/', templateParams);

    if (response.template.length < 1) {
      template.value = null;
      if (!['regwithprops', 'regular', '0'].includes(internalModelValue.value)) {
        isDeleted.value = true;
      }
      loadingTemplate.value = false;
      return;
    }

    template.value = response.template[0];
    //@ts-ignore
    let fields = template.value['field'].map((field) => {
      let modifications = field['modifications'] || {};
      return {
        fieldName: field.fieldName,
        newColHeader: modifications.newColHeader ?? '',
        fieldType: field.fieldType,
      };
    });

    template.value['field'] = fields;
    isDeleted.value = false;
  } catch (error) {
    console.error('Error loading template details:', error);
  } finally {
    loadingTemplate.value = false;
  }
}

function selectTemplate(option) {
  if (option.value === 'defineCustomTemplate') {
    router.value.push({ name: 'account.scans.templates.new' });
  } else {
    internalModelValue.value = option.value;
  }
}

function formatDate(date, format) {
  return moment(date).format(format);
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showEdit.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_infinite_scroll, {
            color: "black",
            mode: "manual",
            style: {"height":"100%","max-height":"400px"},
            onLoad: loadMore
          }, {
            empty: _withCtx(() => [
              _createTextVNode(" No more results ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_radio_group, {
                modelValue: internalModelValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalModelValue).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    density: "compact",
                    class: "bg-grey-lighten-4"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTemplateNames.value, (option) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: option.value,
                          onClick: ($event: any) => (selectTemplate(option))
                        }, {
                          default: _withCtx(() => [
                            (option.value === 'defineCustomTemplate')
                              ? (_openBlock(), _createBlock(_component_v_list_item_title, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(option.title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              : (_openBlock(), _createBlock(_component_v_list_item_action, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                      value: option.value,
                                      label: option.title
                                    }, null, 8 /* PROPS */, ["value", "label"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    (showDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (loadingTemplate.value)
            ? (_openBlock(), _createBlock(SpinnerComponent, {
                key: 0,
                text: "Loading, please wait..."
              }))
            : (!loadingTemplate.value && template.value && Object.keys(template.value).length > 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode("Template Name: "),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(template.value['templateName']), 1 /* TEXT */)
                    ]),
                    (showEdit.value && template.value && template.value['templateId'])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (template.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {name: 'account.scans.templates.edit', params: {templateID: template.value['templateId']}},
                                target: "_blank",
                                class: "text-black"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_v_icon, {
                                      size: "20",
                                      class: "px-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-pencil")
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createTextVNode("Edit")
                                  ])
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["to"]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, "created on: " + _toDisplayString(formatDate(template.value['createdTimestamp'], 'lll')), 1 /* TEXT */)
                  ]),
                  _createVNode(_component_v_card, {
                    class: "rounded-1 pa-3 mt-2",
                    variant: "outlined"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(fieldContainerTitle.value), 1 /* TEXT */),
                          (!template.value['field'])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "This template contains no columns"))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.value['field'], (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.fieldName,
                              class: "list_template_cell"
                            }, [
                              (field.newColHeader != '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("strong", null, _toDisplayString(field.newColHeader), 1 /* TEXT */)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (field.newColHeader == '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    (field.fieldType == 'system')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          _createElementVNode("strong", null, _toDisplayString(field.fieldName), 1 /* TEXT */)
                                        ]))
                                      : (field.fieldType == 'questions')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createTextVNode("Question: "),
                                            _createElementVNode("strong", null, _toDisplayString(field.fieldName), 1 /* TEXT */)
                                          ]))
                                        : (field.fieldType == 'properties')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                              _createTextVNode("Property: "),
                                              _createElementVNode("strong", null, _toDisplayString(field.fieldName), 1 /* TEXT */)
                                            ]))
                                          : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})